<div class="container py-5">
    <div class="row text-center align-items-center">

        <!-- Année de création -->
        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-hand-holding-heart fa-2x text-primary"></i>
                </div>
                <h3><span>2025</span></h3>
                <p>Année de création d’ASESA</p>
            </div>
        </div>

        <!-- Santé -->
        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-hospital fa-2x text-success"></i>
                </div>
                <h3><span>+</span></h3>
                <p>Actions de santé communautaire</p>
            </div>
        </div>

        <!-- Éducation -->
        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-school fa-2x text-warning"></i>
                </div>
                <h3><span>+</span></h3>
                <p>Initiatives éducatives locales</p>
            </div>
        </div>

        <!-- Eau & hygiène -->
        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-tint fa-2x text-info"></i>
                </div>
                <h3><span>+</span></h3>
                <p>Accès à l’eau potable et à l’hygiène</p>
            </div>
        </div>

    </div>
</div>
